export default class Email {
  from_name: string = "";
  message: string = "";
  email_address: string = "";
}
